import { render } from "./PopUpShare.vue?vue&type=template&id=1e38d5b0"
import script from "./PopUpShare.vue?vue&type=script&lang=js"
export * from "./PopUpShare.vue?vue&type=script&lang=js"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__